import { application_dependencies_path, application_overview_path, application_remotes_path, application_settings_general_path, application_settings_tags_path, application_uml_path, application_versions_path, authenticated_user_profile_path, organization_managed_applications_path, organization_path, organization_projects_path, organization_settings_path, project_application_list_path, project_overview_path, project_settings_deployment_integrations_path, project_settings_general_path, RouteNames, user_path, user_settings_path } from '@repo/routes';
import { NavBarItemId, navigations } from './navigation-constants';
export function navigationItemsOrgLevel(param) {
    let { organization } = param;
    const items = [
        {
            title: navigations[NavBarItemId.DASHBOARD].title,
            id: NavBarItemId.DASHBOARD,
            path: RouteNames.ORGANIZATION,
            link: organization_path({
                organization
            }),
            exact: true
        },
        {
            title: navigations[NavBarItemId.PROJECTS].title,
            id: NavBarItemId.PROJECTS,
            path: RouteNames.ORGANIZATION_PROJECTS,
            link: organization_projects_path({
                organization
            })
        },
        {
            title: navigations[NavBarItemId.APPLICATIONS].title,
            id: NavBarItemId.APPLICATIONS,
            path: RouteNames.ORGANIZATION_MANAGED_APPLICATIONS,
            link: organization_managed_applications_path({
                organization
            }),
            availablePaths: [
                RouteNames.ORGANIZATION_MANAGED_APPLICATIONS,
                RouteNames.ORGANIZATION_UNMANAGED_APPLICATIONS,
                RouteNames.ORGANIZATION_UNMANAGED_APPLICATION_NEW,
                RouteNames.ORGANIZATION_UNMANAGED_APPLICATION_EDIT
            ]
        }
    ];
    if (organization.settingsAvailable) {
        items.push({
            title: navigations[NavBarItemId.SETTINGS].title,
            id: NavBarItemId.SETTINGS,
            path: RouteNames.ORGANIZATION_SETTINGS,
            link: organization_settings_path({
                organization
            }),
            availablePaths: [
                RouteNames.ORGANIZATION_SETTINGS,
                RouteNames.ORGANIZATION_MEMBERSHIP,
                RouteNames.ORGANIZATION_SUBSCRIPTION,
                RouteNames.ORGANIZATION_SUBSCRIPTION_MANAGE,
                RouteNames.ORGANIZATION_BILLING_HISTORY,
                RouteNames.ORGANIZATION_PAYMENT_METHODS,
                RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION_LIST,
                RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION_OVERVIEW,
                RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION,
                RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION_ADD,
                RouteNames.ORGANIZATION_DEPLOYMENT_INTEGRATION_EDIT
            ]
        });
    }
    return items;
}
export function navigationItemsProjectLevel(param) {
    let { organization, project } = param;
    const items = [
        {
            title: navigations[NavBarItemId.PROJECT_OVERVIEW].title,
            id: NavBarItemId.PROJECT_OVERVIEW,
            path: RouteNames.PROJECT_OVERVIEW,
            link: project_overview_path({
                organization,
                project
            }),
            exact: true
        },
        {
            title: navigations[NavBarItemId.PROJECT_APPLICATION_LIST].title,
            id: NavBarItemId.PROJECT_APPLICATION_LIST,
            path: RouteNames.PROJECT_APPLICATION_LIST,
            link: project_application_list_path({
                organization,
                project
            })
        }
    ];
    if (project.settingsAvailable) {
        items.push({
            title: navigations[NavBarItemId.DEVOPS].title,
            id: NavBarItemId.DEVOPS,
            path: RouteNames.PROJECT_SETTINGS_DEPLOYMENT_INTEGRATION_LIST,
            link: project_settings_deployment_integrations_path({
                organization,
                project
            }),
            availablePaths: [
                RouteNames.PROJECT_SETTINGS_DEPLOYMENT_INTEGRATION_LIST
            ]
        }, {
            title: navigations[NavBarItemId.PROJECT_SETTINGS].title,
            id: NavBarItemId.PROJECT_SETTINGS,
            path: RouteNames.PROJECT_SETTINGS_GENERAL,
            link: project_settings_general_path({
                organization,
                project
            }),
            availablePaths: [
                RouteNames.PROJECT_SETTINGS_GENERAL,
                RouteNames.PROJECT_SETTINGS_COLLABORATORS_AND_TEAM
            ]
        });
    }
    return items;
}
export function navigationItemsAppLevel(param) {
    let { organization, project, application } = param;
    const items = [
        {
            title: navigations[NavBarItemId.PROJECT_OVERVIEW].title,
            id: NavBarItemId.PROJECT_OVERVIEW,
            path: '/org/$organization/$project/$application/',
            link: application_overview_path({
                organization,
                project,
                application
            }),
            exact: true
        },
        {
            title: navigations[NavBarItemId.PROJECT_VERSIONS].title,
            id: NavBarItemId.PROJECT_VERSIONS,
            path: RouteNames.APPLICATION_VERSIONS,
            link: application_versions_path({
                organization,
                project,
                application
            })
        },
        {
            title: navigations[NavBarItemId.PROJECT_UML].title,
            id: NavBarItemId.PROJECT_UML,
            path: RouteNames.APPLICATION_UML,
            link: application_uml_path({
                organization,
                project,
                application
            })
        },
        {
            title: navigations[NavBarItemId.PROJECT_REMOTES].title,
            id: NavBarItemId.PROJECT_REMOTES,
            path: RouteNames.APPLICATION_REMOTES,
            link: application_remotes_path({
                organization,
                project,
                application
            }),
            availablePaths: [
                RouteNames.APPLICATION_REMOTES,
                RouteNames.APPLICATION_MODULE
            ]
        },
        {
            title: navigations[NavBarItemId.PROJECT_ANALYTICS].title,
            id: NavBarItemId.PROJECT_ANALYTICS,
            path: RouteNames.APPLICATION_DEPENDENCIES,
            link: application_dependencies_path({
                organization,
                project,
                application
            }),
            availablePaths: [
                RouteNames.APPLICATION_DEPENDENCIES,
                RouteNames.APPLICATION_DEPENDENCY_GRAPH,
                RouteNames.APPLICATION_NODE_GRAPH,
                RouteNames.APPLICATION_NODE_DEPENDENCIES
            ]
        }
    ];
    if (application.settingsAvailable && application.devopsAvailable) {
        items.push({
            title: navigations[NavBarItemId.DEVOPS].title,
            id: NavBarItemId.DEVOPS,
            path: RouteNames.APPLICATION_DEVOPS_TAGS,
            link: application_settings_tags_path({
                organization,
                project,
                application
            }),
            activeBasePath: "/org/".concat(organization.name, "/").concat(project.name, "/").concat(application.name, "/devops"),
            availablePaths: [
                RouteNames.APPLICATION_DEVOPS_RELEASE_PIPELINE,
                RouteNames.APPLICATION_DEVOPS_RELEASE_PIPELINE_BOARD,
                RouteNames.APPLICATION_DEVOPS_TAGS,
                RouteNames.APPLICATION_DEVOPS_TAGS_ADD,
                RouteNames.APPLICATION_DEVOPS_TAGS_EDIT,
                RouteNames.APPLICATION_DEVOPS_ENVIRONMENT_LIST,
                RouteNames.APPLICATION_DEVOPS_ENVIRONMENT_ADD,
                RouteNames.APPLICATION_DEVOPS_ENVIRONMENT_EDIT,
                RouteNames.APPLICATION_DEVOPS_DEPLOYMENT_INTEGRATION_LIST,
                RouteNames.APPLICATION_DEVOPS_DEPLOYMENT_AND_ROLLBACK
            ]
        });
    }
    if (application.settingsAvailable) {
        items.push({
            title: navigations[NavBarItemId.APPLICATION_SETTINGS].title,
            id: NavBarItemId.APPLICATION_SETTINGS,
            path: RouteNames.APPLICATION_SETTINGS,
            link: application_settings_general_path({
                organization,
                project,
                application
            }),
            availablePaths: [
                RouteNames.APPLICATION_SETTINGS,
                RouteNames.APPLICATION_CONTRIBUTOR_LIST
            ]
        });
    }
    return items;
}
export function navigationItemsProfileLevel(param) {
    let { user } = param;
    return [
        {
            title: navigations[NavBarItemId.PROFILE_OVERVIEW].title,
            id: NavBarItemId.PROJECT_OVERVIEW,
            path: RouteNames.USER_PROFILE,
            link: user_path({
                username: user.name
            }),
            exact: true
        }
    ];
}
export function navigationItemsAuthenticatedUserProfileLevel() {
    return [
        {
            title: navigations[NavBarItemId.PROFILE_OVERVIEW].title,
            id: NavBarItemId.PROJECT_OVERVIEW,
            path: RouteNames.AUTHENTICATED_USER_PROFILE,
            link: authenticated_user_profile_path(),
            exact: true
        },
        {
            title: navigations[NavBarItemId.PROFILE_SETTINGS].title,
            id: NavBarItemId.PROFILE_SETTINGS,
            path: RouteNames.USER_PROFILE_SETTINGS,
            link: user_settings_path(),
            availablePaths: [
                RouteNames.USER_PROFILE_SETTINGS,
                RouteNames.USER_PROFILE_SETTINGS_EMAILS,
                RouteNames.USER_PROFILE_SETTINGS_USER_TOKENS,
                RouteNames.USER_PROFILE_SETTINGS_EDIT_USER_TOKEN,
                RouteNames.USER_PROFILE_SETTINGS_GENERATE_USER_TOKENS
            ]
        }
    ];
}
